// extracted by css-extract-rspack-plugin
export default {"row":"StatisticCustomerSheetTable_row__vr03W"};